import { DicomMetadataStore } from '@ohif/core';
import React, { useState, useEffect } from 'react';

import { DeleteDicomSend } from '../button/DelateDicom';

const DeleteDicom = ({ seriesNumberCont }: { seriesNumberCont: string }) => {
  const [showModal, setShowModal] = useState(false);
  const [study, setStudy] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Cargar el estudio desde el store de OHIF
    const fetchStudy = async () => {
      try {
        const fetchedStudy = DicomMetadataStore.getStudy(seriesNumberCont);
        if (fetchedStudy && fetchedStudy.isLoaded) {
          setStudy(fetchedStudy);
        } else {
          console.warn('Estudio no encontrado o no cargado aún');
        }
      } catch (error) {
        console.error('Error al cargar el estudio:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStudy();
  }, [seriesNumberCont]);

  if (loading) {
    return <div className="p-4 text-white">Cargando datos del estudio...</div>;
  }

  if (!study) {
    return <div className="p-4 text-red-400">No se encontró información del estudio.</div>;
  }

  const seriesList = study.series || [];

  return (
    <div className="w-full">
      <button
        onClick={() => setShowModal(true)}
        className="flex h-full w-full justify-center rounded bg-transparent text-sm sm:text-base"
      >
        Eliminar
      </button>

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black bg-opacity-60 text-white">
          <div className="bg-secondary-dark max-w-2xl overflow-auto rounded p-6 shadow-lg sm:w-full">
            <h2 className="mb-4 text-center text-lg font-semibold">
              {study.StudyDescription || 'Estudio sin descripción'}
            </h2>
            <table className="min-w-full bg-white text-left text-sm text-gray-700">
              <thead className="bg-gray-200 text-gray-900">
                <tr>
                  <th className="px-6 py-3">Descripción</th>
                  <th className="px-6 py-3"># Instancias</th>
                  <th className="px-6 py-3">Modalidad</th>
                  <th className="px-6 py-3"></th>
                </tr>
              </thead>
              <tbody>
                {seriesList.map((serie: any, index: number) => (
                  <tr
                    key={serie.SeriesInstanceUID || index}
                    className="border-b hover:bg-gray-100"
                  >
                    <td className="px-6 py-4">{serie.SeriesDescription || 'Sin descripción'}</td>
                    <td className="px-6 py-4">
                      {serie.instances?.length || serie.NumberOfSeriesRelatedInstances || 0}
                    </td>
                    <td className="px-6 py-4">{serie.Modality || 'N/A'}</td>
                    <td className="px-6 py-4">
                      <button
                        onClick={() => console.log('Enviar serie:', serie.SeriesInstanceUID)}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <DeleteDicomSend
                          seriesNumberCont={serie.instances || serie.instances || 0}
                          sopInstanceUid={String(seriesNumberCont)}
                        ></DeleteDicomSend>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="mt-4 flex justify-end">
              <button
                onClick={() => setShowModal(false)}
                className="rounded bg-gray-600 px-4 py-2 text-white hover:bg-gray-700"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteDicom;
